const $ = jQuery.noConflict();

const createAnchorTags = function () {
	// Ensure that the 'secondary-nav__selected-menu' div exists
	let selectedMenuDiv = $('.secondary-nav__selected-menu');
	if (selectedMenuDiv.length === 0) {
		selectedMenuDiv = $('<div class="secondary-nav__selected-menu"></div>');
		$('.secondary-nav__items').prepend(selectedMenuDiv);
	}

	$('section[id]').each(function (index) {
		const id = $(this).attr('id');
		const title = toTitleCase(id.replace(/-|_/g, ' ')); // Replace '-' or '_' with a space and capitalize

		const anchor = $('<a class="has-nav-1-font-size"></a>')
			.attr('href', '#' + id)
			.text(title);

		// Attach click event listener to update the selected menu text and remove 'active' class from 'secondary-nav'
		anchor.on('click', function () {
			selectedMenuDiv.text($(this).text());
			$('.secondary-nav').removeClass('active');
		});

		$('.secondary-nav__items').append(anchor);

		// If it's the first anchor, copy it into the selected menu div
		if (index === 0) {
			selectedMenuDiv.text(title);
		}
	});

	// Add click event to 'secondary-nav__selected-menu' to toggle 'active' class on 'secondary-nav'
	selectedMenuDiv.on('click', function () {
		$('.secondary-nav').toggleClass('active');
	});
};

function toTitleCase(str) {
	return str.replace(/\w\S*/g, function (txt) {
		return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
	});
}

// GLOBAL APP CONTROLLER
const controller = {
	init() {},
	loaded() {
		createAnchorTags();
	},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};

export default controller;
